export const supportedCountries = [
  {
    key: 'us',
    value: 'us',
    flag: 'us',
    text: 'United States',
  },
  {
    key: 'uk',
    value: 'uk',
    flag: 'gb',
    text: 'United Kingdom',
  },
  {
    key: 'au',
    value: 'au',
    flag: 'au',
    text: 'Australia',
  },
  {
    key: 'nz',
    value: 'nz',
    flag: 'nz',
    text: 'New Zealand',
  },
  {
    key: 'de',
    value: 'de',
    flag: 'de',
    text: 'Germany',
  },
  {
    key: 'it',
    value: 'it',
    flag: 'it',
    text: 'Italy',
  },
  {
    key: 'kr',
    value: 'kr',
    flag: 'kr',
    text: 'South Korea',
  },
];
